const Style = {

  selector: 'absolute top-1/2 -translate-y-2/4 right-0 z-[6] px-2',
  project: 'flex items-center cursor-pointer justify-end',
  name: 'text-md font-semibold mr-4',

} 

export default Style;